import PropTypes from 'prop-types'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import classNames from 'classnames'

import forwardTransitions from './slide-forward.scss'
import backTransitions from './slide-back.scss'

const SlideTransition = ({ back, enable, children }) =>
  enable ? (
    <ReactCSSTransitionGroup
      transitionName={back ? backTransitions : forwardTransitions}
      transitionEnterTimeout={800}
      transitionLeaveTimeout={800}
    >
      {children}
    </ReactCSSTransitionGroup>
  ) : (
    children
  )

SlideTransition.propTypes = {
  back: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default SlideTransition

export const HideInTransitionClassNames = classNames(
  forwardTransitions.hiddenWhileTransitioning,
  backTransitions.hiddenWhileTransitioning
)
